import { Capacitor } from '@capacitor/core';
import type { NativeVersionSettings } from '~/utils/nativeVersion';

// Compares the native app version with the versions configured in the admin system settings
// on app start and whenever the app returns to the foreground (see components/NativeAppUpdateNotice.vue).
export default defineNuxtPlugin(() => {
  if (!Capacitor.isNativePlatform()) return;

  const update = useNativeAppUpdate();
  const { baseURL } = useRuntimeConfig().public;

  import('@capacitor/app').then(async ({ App }) => {
    const { version } = await App.getInfo();

    const check = async () => {
      try {
        const response = await $fetch<{ data: NativeVersionSettings }>('/public/status', { baseURL });
        const { min, recommended } = selectNativeVersions(response.data, Capacitor.getPlatform());
        update.value = {
          status: resolveNativeUpdateStatus(version, min, recommended),
          recommendedVersion: recommended,
        };
      } catch {
        // offline or server unreachable: keep the last known status
      }
    };

    await check();
    App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) check();
    });
  });
});
